import React from "react";
import ReactDOM from "react-dom";
import "babel-polyfill";
import "./normalize.css";
import "./animate.css";
import RouteComponent from "./components/RouteComponent/main";
import { BrowserRouter } from "react-router-dom";
import eruda from "eruda";

import BASE_CONFIG from "./api/env";
// import registerServiceWorker from './registerServiceWorker';

if (BASE_CONFIG.env !== "pre" && BASE_CONFIG.env !== "prod") {
    eruda.init({ useShadowDom: true });
}

ReactDOM.render(
    <BrowserRouter>
        <RouteComponent />
    </BrowserRouter>,
    document.getElementById("root")
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js